module.exports = __webpack_public_path__ + "static/media/style_binary.84361142.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/terminology/assets/style_binary.png
// module id = 135
// module chunks = 0